import { ParsedUrlQuery } from 'querystring';

export function getFurnishedState(query: ParsedUrlQuery) {
    if (query['furnished_state']) {
        return query['furnished_state'];
    }

    return '';
}
